<template>
<div class="col-lg-3 xs-hide md-hide pl-0">
<div>
    <div class="col-12 text-center">
        <a v-if="isLoggedIn" target="_self" href="https://houseandflats.com/">                  
            <img style="width:40%" class="img-fluid mt-5" src="../assets/logo.png" >
        </a>
    </div>
    <div class="col-12 text-center">
        <div class="circular--portrait mb-3">
            <div class="text-center mt-0">
                <img v-bind:src="url+'perfil/'+user.imagen"/>                
            </div>        
        </div>
        <br>
        <div style="top:159px; left: calc(100% - 40%);">
            <div>
            <font-awesome-icon :style="{ color: '#5A287F' }" size="2x" :icon="['fa', 'camera']" /> 
            </div>
            <label style="cursor:pointer;" class="c-file-input__label js-file-input__label" for="fuser">     
                <input 
                id="fuser"
                type="button" 
                name="attachment" 
                class="c-file-input__field js-file-input__field"
                onclick="document.getElementById('uimagen').click();" 
                >
            </label>
            <b-form-file @change="updateProfileImagen" id="uimagen"  style="display:none;"></b-form-file>                 
        </div>
        <label class="name-profile">{{user.nombre}}</label>
        <p class="sub-profile" v-if="user.is_admin == 1">Administrador</p>
        <div class="starts-color">
            <font-awesome-icon :style="{ color: '#5A287F' }" size="1x" :icon="['fa', 'star']" />
            <font-awesome-icon :style="{ color: '#5A287F' }" size="1x" :icon="['fa', 'star']" />
            <font-awesome-icon :style="{ color: '#5A287F' }" size="1x" :icon="['fa', 'star']" />
            <font-awesome-icon :style="{ color: '#5A287F' }" size="1x" :icon="['fa', 'star']" />
            <font-awesome-icon :style="{ color: '#5A287F' }" size="1x" :icon="['fa', 'star']" />
        </div>
        <font-awesome-icon :style="{ color: '#A2C037' }" size="1x" :icon="['fa', 'circle']" />Online
    </div>
    <div class="col-12  mt-4 ml-4">
        <hr class="custom">
        <div class="mt-3">         
            <img width="8%" src="../assets/1.svg">
            <label v-if="iso639_1 === 'es'" class="sub-profile ml-4">
                <router-link v-if="isLoggedIn" to="/dashboard">
                    Mis Alojamientos
                </router-link>
            </label> 
            <label v-else class="sub-profile ml-4">
                <router-link v-if="isLoggedIn" to="/dashboard">
                    My Accommodations
                </router-link>
            </label>             
         </div>

        <hr class="custom">
            <div class="mt-3">
                <img width="8%" src="../assets/2.svg">
                <label v-if="iso639_1 === 'es'" class="sub-profile ml-4">
                    <router-link v-if="isLoggedIn"  to="/editar-perfil">
                    Editar perfil
                    </router-link> 
                </label> 
                <label v-else class="sub-profile ml-4">
                    <router-link v-if="isLoggedIn"  to="/editar-perfil">
                    Edit profile
                    </router-link> 
                </label>                 
            </div>

        <hr class="custom">       
            <div class="mt-3">     
                <img width="8%" src="../assets/contra.svg">
                <label v-if="iso639_1 === 'es'" class="sub-profile ml-4">
                    <router-link  v-if="isLoggedIn"  to="/cambiar-password">                 
                        Cambiar contraseña
                    </router-link>
                </label>
                <label v-else class="sub-profile ml-4">
                    <router-link  v-if="isLoggedIn"  to="/cambiar-password">                 
                        Change Password
                    </router-link>
                </label>                  
            </div>  
        <hr class="custom">    
            <div class="mt-3">
            <img width="8%" src="../assets/4.svg"> 
            <label v-if="iso639_1 === 'es'" class="sub-profile ml-4">
                <router-link v-if="isLoggedIn"  to="/registro-alojamiento">                     
                    Agregar alojamiento
                </router-link>  
            </label> 
            <label v-else class="sub-profile ml-4">
                <router-link  v-if="isLoggedIn" to="/registro-alojamiento">                 
                    Add accommodation
                </router-link>
            </label>              
            </div>
        <hr class="custom"> 
            <div class="mt-3">
            <img width="8%" src="../assets/magnifying-glass.svg"> 
            <label v-if="iso639_1 === 'es'" class="sub-profile ml-4">
              <a href="https://houseandflats.com/explore" target="_blank">Buscar propiedades</a>
            </label> 
            <label v-else class="sub-profile ml-4">
               <a href="https://houseandflats.com/explore" target="_blank">Search properties</a>
            </label>              
            </div>            
     <hr class="custom">  
 
            <div  class="mt-3">
            <img width="8%" src="../assets/5.svg">
            <label v-if="iso639_1 === 'es'" class="sub-profile ml-4">
              <!--
                <a v-if="isLoggedIn" @click="logout()">Cerrar sesión</a> 
                -->
                 <a style="cursor: pointer;" v-if="isLoggedIn" @click="logout()">Cerrar sesión</a>
            </label> 
            <label v-else class="sub-profile ml-4">
              <!--
              <a v-if="isLoggedIn" @click="logout()">Sign off</a> 
              -->
               <a style="cursor: pointer;" v-if="isLoggedIn" @click="logout()">Sign off</a>
           </label> 
            </div>
        
        <hr class="custom"> 
    </div>
    <div class="col-12 mt-5 mb-5 text-center sub-profile">
        House&Flats © 2019 <br>
        Todos los derechos reservados.
    </div>
</div>
  
</div>  

</template>

<script>
import { mapActions, mapState } from "vuex";
import axios from 'axios'
  export default {
    name: 'Navbar',
    data(){
        return {
                 url : process.env.VUE_APP_S3_URL
        }
    },    
    methods:{
        ...mapActions(['logout']),
        updateProfileImagen(event) {
          let fotodata = new FormData()
          fotodata.append('foto', event.target.files[0])
          return new Promise(() => {
              axios({url: process.env.VUE_APP_API_URL+'users/updatePhoto', data: fotodata, method: 'POST' })
              .then(resp => {
                this.$store.state.user.imagen = resp.data.imagen
                localStorage.setItem('imagen', resp.data.imagen)
              })
          })              
      }       
    },
    computed : {
       isLoggedIn : function(){ return this.$store.getters.isLoggedIn},
       ...mapState(['user', 'language', 'iso639_1'])
    },
    created: function () {
      this.$http.interceptors.response.use(undefined, function (err) {
        return new Promise(function (resolve, reject) {
          if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
            this.$store.dispatch(logout)
          }
          throw err;
        });
      });
    }
  }
</script>


<style scoped>
.circular--portrait {
  position: relative;
  width: 150px;
  height: 150px;
  overflow: hidden;
  border-radius: 50%;
  margin: auto;
  border: 1px solid rgba(90, 40, 127, 0.8);
  box-shadow: 1px 2px 4px 0px rgba(90, 40, 127, 0.8);
  top: 30px;
}

.circular--portrait img {
  width: 150%;
  height: auto;
}

.c-field__error {
  font-size: 12px;
  color: #d71149;
}

.c-file-input {
  position: relative;
  display: block;
  height: 200px;
  width: 100%;
  border: 2px dashed #5A287F;
  background-color: #fff;
}

/* line 24, app/assets/stylesheets/mweb/6-components/_components.file-input.scss */
.c-file-input:invalid,
.c-field--error .c-file-input {
  background-color: #ffe6e9;
  border-color: #ff566a;
}

/* line 28, app/assets/stylesheets/mweb/6-components/_components.file-input.scss */
.c-file-input:invalid:focus,
.c-field--error .c-file-input:focus {
  background-color: #ffe6e9;
  border-color: #ff566a;
}

/* line 34, app/assets/stylesheets/mweb/6-components/_components.file-input.scss */
.c-file-input__label {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding-left: 36px;
  padding-right: 36px;
  line-height: 36px;
  color: #999;
  font-size: 12px;
  overflow: hidden;
  word-wrap: break-word;
  z-index: 1;
}

/* line 50, app/assets/stylesheets/mweb/6-components/_components.file-input.scss */
.c-file-input__field {
  position: absolute !important;
  height: 1px !important;
  width: 1px !important;
  padding: 0 !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  z-index: -1;
}

/* line 59, app/assets/stylesheets/mweb/6-components/_components.file-input.scss */
.c-file-input__field:focus {
  outline: none;
}

/* line 64, app/assets/stylesheets/mweb/6-components/_components.file-input.scss */
.c-file-input__indicator {
  position: absolute;
  left: calc(60% - 62px);
  top: 30px;
  height: 100%;
  width: 86px;
  z-index: 0;
}

/* line 73, app/assets/stylesheets/mweb/6-components/_components.file-input.scss */
.c-file-input__indicator__icon {
  color: #bbb;
  position: absolute;
  top: 50%;
  -webkit-transform: translate(0, -50%);
      -ms-transform: translate(0, -50%);
       -o-transform: translate(0, -50%);
          transform: translate(0, -50%);
  left: 4px;
  font-size: 20px;
}

/* line 81, app/assets/stylesheets/mweb/6-components/_components.file-input.scss */
.has-file .c-file-input__indicator__icon {
  color: #d71149;
}

/* line 86, app/assets/stylesheets/mweb/6-components/_components.file-input.scss */
.c-file-input__remove {
  display: none;
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 36px;
  z-index: 2;
}

.has-file > .c-file-input__remove {
  display: block;
}

/* line 100, app/assets/stylesheets/mweb/6-components/_components.file-input.scss */
.c-file-input__remove__icon {
  position: absolute;
  top: 50%;
  -webkit-transform: translate(0, -50%);
      -ms-transform: translate(0, -50%);
       -o-transform: translate(0, -50%);
          transform: translate(0, -50%);
  left: 4px;
  font-size: 20px;
  color: #ff566a;
}
</style>
